import m from "./index.es105.js";
import i from "./index.es110.js";
import b from "./index.es99.js";
const p = (e, t) => {
  const { length: f } = e = e ? e.filter(Boolean) : [];
  if (t || f) {
    let a = new AbortController(), c;
    const r = function(o) {
      if (!c) {
        c = !0, l();
        const n = o instanceof Error ? o : this.reason;
        a.abort(n instanceof i ? n : new m(n instanceof Error ? n.message : n));
      }
    };
    let s = t && setTimeout(() => {
      s = null, r(new i(`timeout ${t} of ms exceeded`, i.ETIMEDOUT));
    }, t);
    const l = () => {
      e && (s && clearTimeout(s), s = null, e.forEach((o) => {
        o.unsubscribe ? o.unsubscribe(r) : o.removeEventListener("abort", r);
      }), e = null);
    };
    e.forEach((o) => o.addEventListener("abort", r));
    const { signal: u } = a;
    return u.unsubscribe = () => b.asap(l), u;
  }
};
export {
  p as default
};
//# sourceMappingURL=index.es178.js.map
